<template>
  <div class="py-1 px-2 text-center border-r border-gray-200 dark:border-gray-700">
    <span class="font-mono text-sm" v-if="value">
      &euro;{{ formattedValue }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  value?: number | string;
  col?: number;
}>();

const formattedValue = computed(() => {
  if (!props.value) return '';

  let numericValue = props.value;
  if (typeof props.value === 'string') {
    numericValue = parseFloat(props.value) || 0;
  }

  return (numericValue as number).toLocaleString('nl-NL', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
});
</script>
